import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import Load from './Load';
import Pagination from './Pagination';
import {
  SEGUIDOS_POR_ATLETA,
  SeguidosPorAtletaData,
  SeguidosPorAtletaVars,
} from '../services/seguidorService';
import { resolverExibicaoSeguido } from '../utils/seguidoDisplay';

interface AtletaSeguindoTabProps {
  atletaId: string;
}

const PAGE_SIZE = 9;

const AtletaSeguindoTab: React.FC<AtletaSeguindoTabProps> = ({ atletaId }) => {
  const [page, setPage] = useState(0);
  const navigate = useNavigate();

  const { data, loading, error } = useQuery<
    SeguidosPorAtletaData,
    SeguidosPorAtletaVars
  >(SEGUIDOS_POR_ATLETA, {
    variables: { atletaId, page, size: PAGE_SIZE },
    skip: !atletaId,
  });

  if (loading) {
    return <Load />;
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Erro ao carregar perfis seguidos.
      </div>
    );
  }

  const items = data?.seguidosPorAtletaId.items ?? [];
  const totalPages = data?.seguidosPorAtletaId.totalPages ?? 0;

  if (items.length === 0) {
    return (
      <div>
        <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
          <div className="card-body text-center">
            <p className="mb-0">Nenhum perfil seguido.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="row g-3">
        {items.map((seguido) => {
          const { nome, username, imageUrl, path } = resolverExibicaoSeguido(seguido);
          const onClick = () => navigate(path);

          return (
            <div key={seguido.id} className="col-12 col-sm-6 col-lg-4">
              <div
                className="card w-100 shadow-xss rounded-xxl border-0 p-3 hover-card"
                style={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
                onClick={onClick}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick();
                  }
                }}
              >
                <div className="d-flex align-items-center">
                  <figure className="avatar me-3 mb-0">
                    <img
                      src={imageUrl || '/assets/images/avatar.jpg'}
                      alt={nome}
                      className="rounded-circle w-100"
                      style={{ width: 48, height: 48, objectFit: 'cover' }}
                    />
                  </figure>
                  <div className="flex-grow-1 min-w-0">
                    <div className="fw-600 text-grey-900 text-truncate">
                      {nome}
                    </div>
                    {username && (
                      <div className="font-xssss text-primary text-truncate">
                        @{username}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-3">
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </div>
    </div>
  );
};

export default AtletaSeguindoTab;
